import styled from 'styled-components';

export const SelectWrapper = styled.div`
  width: 120px;
`;
